<nb-card class="m-0" *ngIf="productos && productos.length >0 && numeroPieza">
  <nb-card-body>
    <div class="row mb-4">
      <div class="col-12">
        <h5>Se encontraron {{productos.length}} productos con el número de pieza {{numeroPieza}}, elija el que desee
          utilizar.</h5>
      </div>
    </div>
    <div class="row mb-3" *ngFor="let producto of productos">
      <div class="col-auto align-self-center">
        <span>{{producto.descripcion}} - {{producto.marca ? producto.marca : 'Sin marca.'}} -
          {{producto.calidad}}</span>
      </div>
      <div class="col">
       <button class="btn btn-primary btn-sm" (click)="seleccionar(producto)">Seleccionar</button>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col">
        <button class="btn btn-secondary btn-sm" (click)="cancelar()">Cancelar</button>
      </div>
    </div>
  </nb-card-body>
</nb-card>